var tabsContent = 'fx_2d2fb1e5_1wxuitd0';

export { tabsContent };
//# sourceMappingURL=content.vanilla.mjs.map
